import { Checkbox } from '@mantine/core';
import classNames from 'classnames';

import { useUserAgent } from '@/contexts/UserAgentContext';

import { Props } from './types';

const FormCheckbox = ({
  label,
  isRequired = false,
  checked,
  onChange,
  value,
  isError,
}: Props) => {
  const { isMacOS, isAndroid } = useUserAgent();
  const checkboxStyles = classNames(isRequired && 'requiredCheckbox');

  return (
    <Checkbox
      label={label}
      size="lg"
      required={isRequired}
      className={checkboxStyles}
      onChange={onChange}
      aria-checked={checked}
      checked={checked}
      value={value}
      error={
        isError && !checked && <span data-error>Zaznacz wymagane pole</span>
      }
      styles={{
        label: {
          fontFamily: isMacOS || isAndroid ? 'Avenir' : '',
        },
      }}
    />
  );
};

export default FormCheckbox;
